import { render } from "./index.vue?vue&type=template&id=74bb5c38"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/users/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74bb5c38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74bb5c38', __exports__)) {
    api.reload('74bb5c38', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=74bb5c38", () => {
    api.rerender('74bb5c38', render)
  })

}


export default __exports__